<div class="h-100vh pt-50 pb-50" [class.component-dark-theme]="themeService.isDark()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.card-border-radius]="themeService.isCardBorderRadius()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()" *ngIf="!showSuccess">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="tagus-form ms-auto me-auto">
                <div class="title">
                    <div class="d-flex mb-10 align-items-center">
                        <h2 class="mb-0 me-30">Forgot Password?</h2>
                        <img src="assets/img/logo-icon.png" alt="logo-icon" />
                    </div>
                    <p class="leading-snug fs-16">
                        Enter your office email and we'll send you instructions to reset your password in your personal
                        email address, (After you click the reset link button, you will see your personal email address, for example, <b>userXXXXX&#64;gmail.com</b>.)
                    </p>
                </div>
                <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                    <div class="bg-white border-radius p-20 pb-5">
                        <div class="alert alert-success" role="alert" *ngIf="isMailSent">
                            Please Check Your Mail
                        </div>
                        <div class="tagus-form-group without-icon" *ngIf="!isMailSent">
                            <label class="d-block mb-12 fw-semibold gray-color">Office Email Address<span>*</span> (e.g.
                                username&#64;crizac.com)</label>
                            <mat-form-field appearance="fill">
                                <mat-label class="form-label" for="txt-email-address">Enter office email
                                    address</mat-label>
                                <input matInput class="form-control" id="txt-email-address"
                                    placeholder="Enter email address" type="text" formControlName="email" [ngClass]="{
                                        'is-invalid':
                                            showFieldError(f['email']) &&
                                            f['email'].errors
                                    }" />
                            </mat-form-field>
                        </div>
                    </div>
                    <button mat-flat-button class="tagus d-block fw-semibold">
                        Send Reset Link
                    </button>
                    <div class="text-center back-to-login">
                        <a routerLink="/authentication/login" [routerLink]="
                                '/' +
                                AuthenticationRoutes.authentication +
                                '/' +
                                AuthenticationRoutes.login
                            " class="d-inline-block main-color fw-medium position-relative"><i
                                class="flaticon-chevron-1"></i> Back to Login</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-confirm-mail *ngIf="showSuccess" [sentMail]="mailData"></app-confirm-mail>